export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export class ToggleSidebar {
  readonly type = TOGGLE_SIDEBAR;
  readonly payload: boolean;

  constructor(isOpen: boolean) {
    this.payload = isOpen;
  }
}

export type SidebarActions = ToggleSidebar;
